import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		return fg('jsm_va_status_header');
	},
};
